import { z } from 'zod'
import type { TwoFactorSetupChallenge } from '../../models/TwoFactorSetupChallenge'

export const TwoFactorSetupChallengeDTO = z.object({
  setup_challenge_id: z.string().uuid()
})

export type TwoFactorSetupChallengeDTO = z.infer<typeof TwoFactorSetupChallengeDTO>

export function mapDTOToTwoFactorSetupChallenge (dto: TwoFactorSetupChallengeDTO): TwoFactorSetupChallenge {
  return {
    setupChallengeId: dto.setup_challenge_id
  }
}

export function mapTwoFactorSetupChallengeToDTO (model: TwoFactorSetupChallenge): TwoFactorSetupChallengeDTO {
  return {
    setup_challenge_id: model.setupChallengeId
  }
}
